module.exports = __webpack_public_path__ + "img/rockambeckenrand.51bab3f1.png";